function isExternalLink(target, localOrigins) {
    try {
        // When link is relative, this throws an error and we return false in the catch
        const url = new URL(target);
        if (localOrigins) {
            return !localOrigins.includes(url.origin);
        }
        return url.origin !== window.location.origin;
    }
    catch (error) {
        return false;
    }
}

export { isExternalLink };
//# sourceMappingURL=isExternalLink.js.map
